module.exports = __webpack_public_path__ + "img/faq_desktop-01.aeeb5828.svg";